import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class IndustriesService {
    
    constructor() { }

    getIndustries(): Array<any> {
        return [
        {
            display: 'Administrative and Support Services',
            value: 'Administrative and Support Services',
            optionId: '1028'
        },
        {
            display: 'Agriculture',
            value: 'Agriculture',
            optionId: '1030'
        },
        {
            display: 'Arts, Entertainment, and Recreation',
            value: 'Arts, Entertainment, and Recreation',
            optionId: '1032'
        },
        {
            display: 'Automobile Dealers',
            value: 'Automobile Dealers',
            optionId: '1034'
        },
        {
            display: 'Automotive Repair and Maintenance',
            value: 'Automotive Repair and Maintenance',
            optionId: '1036'
        },
        {
            display: 'Business Services',
            value: 'Business Services',
            optionId: '1038'
        },
        {
            display: 'Construction',
            value: 'Construction',
            optionId: '1040'
        },
        {
            display: 'Educational Services',
            value: 'Educational Services',
            optionId: '1042'
        },
        {
            display: 'Finance and Insurance',
            value: 'Finance and Insurance',
            optionId: '1044'
        },
        {
            display: 'Forestry, Fishing, and Hunting',
            value: 'Forestry, Fishing, and Hunting',
            optionId: '1046'
        },
        {
            display: 'Freight Trucking',
            value: 'Freight Trucking',
            optionId: '1048'
        },
        {
            display: 'Gambling Industries',
            value: 'Gambling Industries',
            optionId: '1050'
        },
        {
            display: 'Gas Stations',
            value: 'Gas Stations',
            optionId: '1052'
        },
        {
            display: 'Greenhouse, Nursery, and Floriculture',
            value: 'Greenhouse, Nursery, and Floriculture',
            optionId: '1054'
        },
        {
            display: 'Healthcare and Social Assistance',
            value: 'Healthcare and Social Assistance',
            optionId: '1056'
        },
        {
            display: 'Hotels and Travel Accomodations',
            value: 'Hotels and Travel Accomodations',
            optionId: '1058'
        },
        {
            display: 'Information and Technology',
            value: 'Information and Technology',
            optionId: '1060'
        },
        {
            display: 'Legal Services',
            value: 'Legal Services',
            optionId: '1062'
        },
        {
            display: 'Management of Companies',
            value: 'Management of Companies',
            optionId: '1064'
        },
        {
            display: 'Manufacturing',
            value: 'Manufacturing',
            optionId: '1066'
        },
        {
            display: 'Mining',
            value: 'Mining',
            optionId: '1068'
        },
        {
            display: 'Non-Profit Organizations',
            value: 'Non-Profit Organizations',
            optionId: '1070'
        },
        {
            display: 'Other Services',
            value: 'Other Services',
            optionId: '1072'
        },
        {
            display: 'Personal Care Services',
            value: 'Personal Care Services',
            optionId: '1074'
        },
        {
            display: 'Physician, Dentist, or Health Practitioner',
            value: 'Physician, Dentist, or Health Practitioner',
            optionId: '1076'
        },
        {
            display: 'Public Administration',
            value: 'Public Administration',
            optionId: '1078'
        },
        {
            display: 'Real Estate',
            value: 'Real Estate',
            optionId: '1080'
        },
        {
            display: 'Religious Institutions',
            value: 'Religious Institutions',
            optionId: '1082'
        },
        {
            display: 'Rental and Leasing',
            value: 'Rental and Leasing',
            optionId: '1084'
        },
        {
            display: 'Restaurants and Food Services',
            value: 'Restaurants and Food Services',
            optionId: '1086'
        },
        {
            display: 'Retail Stores',
            value: 'Retail Stores',
            optionId: '1088'
        },
        {
            display: 'Transportation',
            value: 'Transportation',
            optionId: '1090'
        },
        {
            display: 'Utilities',
            value: 'Utilities',
            optionId: '1092'
        },
        {
            display: 'Veterinarians',
            value: 'Veterinarians',
            optionId: '1094'
        },
        {
            display: 'Warehousing and Storage',
            value: 'Warehousing and Storage',
            optionId: '1096'
        },
        {
            display: 'Waste Management &amp; Remediation Services',
            value: 'Waste Management &amp; Remediation Services',
            optionId: '1098'
        },
        {
            display: 'Wholesale Trade',
            value: 'Wholesale Trade',
            optionId: '1100'
        },
        {
            display: 'Professional, Scientific, and Technical Services',
            value: 'Professional, Scientific, and Technical Services',
            optionId: '1102'
        }
    ];
    }
}
